/**
 * useWlGatewayPaymentMethods — lista os meios de pagamento aceitos por um
 * gateway, lendo do Financeiro do tenant master via RPC SECURITY DEFINER.
 *
 * Usado no formulário de Plano (painel WL) para popular dinamicamente os
 * botões de "Meios de pagamento aceitos" a partir do gateway escolhido.
 */
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { createLogger } from "@/lib/logger";

const log = createLogger("useWlGatewayPaymentMethods");

export interface GatewayPaymentMethod {
  id: string;
  nome: string;
  tipo_pagamento: string;
  instrucoes: string | null;
}

export function useWlGatewayPaymentMethods(gatewaySlug: string | null) {
  return useQuery({
    queryKey: ["wl-gateway-payment-methods", gatewaySlug],
    enabled: !!gatewaySlug,
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<GatewayPaymentMethod[]> => {
      const { data, error } = await supabase.rpc(
        "wl_list_gateway_payment_methods" as never,
        { p_gateway_slug: gatewaySlug } as never,
      );
      if (error) {
        log.error("Erro ao listar meios do gateway", { error, gatewaySlug });
        throw error;
      }
      return (data ?? []) as GatewayPaymentMethod[];
    },
  });
}
